//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "mt-step",
  props: {
    status: String
  },
  data() {
    return {
    };
  },
  beforeCreate() {
    this.$parent.steps.push(this);
  },
  computed: {
    stepClass() {
      const status = this.status;
      const statusClass = status ? "mint-step--" + status : "";
      const stepClass = status==='finish'?"mt-color-grey-lv4":"mt-color-grey";
      const directionClass = `mint-step--${this.$parent.direction}`;
      return [directionClass, statusClass,stepClass];
    }
  }
};



// WEBPACK FOOTER //
// ./packages/step/src/step.vue